import { render, staticRenderFns } from "./ZoneMapGradientScale.vue?vue&type=template&id=b63a00c8&scoped=true&"
import script from "./ZoneMapGradientScale.vue?vue&type=script&lang=js&"
export * from "./ZoneMapGradientScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63a00c8",
  null
  
)

export default component.exports